import { render } from "./numbers.vue?vue&type=template&id=712f2a1e"
import script from "./numbers.vue?vue&type=script&lang=js"
export * from "./numbers.vue?vue&type=script&lang=js"

import "./numbers.vue?vue&type=style&index=0&id=712f2a1e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__